var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"datetime flex flex-align"},[_c('input',{staticClass:"block date",attrs:{"disabled":_vm.disabled,"type":"date"},domProps:{"value":_vm.date},on:{"input":_vm.update_date}}),_c('input',{staticClass:"block time",attrs:{"disabled":_vm.disabled,"type":"time"},domProps:{"value":_vm.time},on:{"input":_vm.update_time}})])
}
var staticRenderFns = []

export { render, staticRenderFns }